module.exports = __webpack_public_path__ + "img/greathall_tech_Normal_ua.62156c49.webp";